import React from "react";
import PageHeader from "../components/PageHeader";
import { sansthanImg } from "../assets/assets.js";

export const VividhPooja = () => {
  return (
    <>
      <PageHeader title="पूजा विधी " path="/about-goshala" name=" goshala" />
      {/* <Initiatives /> */}
      <div className="comman-template-section">
        <div className="comman-template-container">
          {/* container  */}
          <div className="comman-template-sub-section">
            {/* sub-section */}
            <div className="comman-template-img-container">
              <img
                className="comman-template-image"
                src={sansthanImg.pujavidhi}
                alt=""
              />
            </div>
            <div className="comman-template-info-container">
              {/* info container */}
              {/* <h3>गोसेवेचे महत्त्व</h3> */}

              <p>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;नित्य प्रातःकाळी
                महाभिषेक पूजेच्या समयी अनेक वैदिक ब्रम्हवृंदांच्या उपस्थितीत
                महापूजा संपन्न होते. श्रींचे उत्सव, सणवार अथवा प्रसंगानुरूप
                रुद्रअभिषेक, रूद्र एकादशनी, महारुद्रअभिषेक, पवमान अभिषेक
                इत्यादी. याप्रमाणे अभिषेक सेवा संपन्न होते.
              </p>
            </div>
          </div>
          {/* second one  */}

          <div className="comman-template-sub-section"></div>
        </div>
      </div>

    </>
  );
};
